exports.MDRT_CALCULATOR_DEFAULT_STATES = {
  defaultQuarterTarget: 150000,
  quarterTarget: 150000,
  avgCaseSize: 6000,
  closingRate: 25,
  isMDRT: 'No',
  isCOT: 'No',
  isTOT: 'No',
  // Production basis (FYC/FYP) while no MDRT tier is selected.
  basis: 'FYC'
};
